import { Component } from '@angular/core';
import { AuthService } from '@/auth/service/auth.service';
import { Privileges } from '@/auth/enum/auth.enum';

@Component({
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent {

  constructor(
    private auth: AuthService,
  ) { }

  get showPersonalRequest(): boolean {
    const acceptedPrivileges: Privileges[] = [
      'LICENSE RENEW PERSONAL_CONTRACTOR',
      'LICENSE RENEW PERSONAL_EMPLOYEE',
    ];

    return acceptedPrivileges.some((privilege) => this.auth.userHavePrivilege(privilege));
  }

  get showThirdPersonRequest(): boolean {
    const acceptedPrivileges: Privileges[] = [
      'LICENSE RENEW THIRD_CONTRACTOR',
      'LICENSE RENEW THIRD_EMPLOYEE',
    ];

    return acceptedPrivileges.some((privilege) => this.auth.userHavePrivilege(privilege));
  }

}
